import { useEffect, useState } from 'react';
import CustomModal from './atoms/CustomModal';
import Button from './atoms/Button';
import getScreenSize from '../utils/getScreenSize';

interface OnBoardingCardProps {
  cards: JSX.Element[];
  mainButton?: {
    title: string;
    onClick: () => void;
  };
  secondaryButton?: {
    title: string;
    onClick: () => void;
  };
  open: boolean;
}

const OnBoardingCard = ({
  cards, mainButton, secondaryButton, open,
}: OnBoardingCardProps) => {
  const [currentCard, setCurrentCard] = useState(0);
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const screenSize = getScreenSize();
  return (
    <>
      {isOpen && (screenSize === 'xs' || screenSize === 'sm' || screenSize === 'md') && <div className="fixed inset-0 bg-surface-base z-50 overflow-hidden h-full flex flex-col">
        <div className="flex flex-col gap-2">
          {cards[currentCard]}
        </div>

        <div className='flex flex-col justify-end mt-auto gap-4 px-4'>
          <div className='flex flex-row justify-between gap-2'>
            {currentCard > 0 && <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" onClick={() => setCurrentCard(currentCard - 1)} className='cursor-pointer'>
              <path d="M30 36L18 24L30 12" stroke="#3F3F46" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>}

            {currentCard < cards.length - 1 && <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" onClick={() => setCurrentCard(currentCard + 1)} className='cursor-pointer ml-auto'>
              <path d="M18 36L30 24L18 12" stroke="#3F3F46" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>}
          </div>

          <div className='flex flex-col mt-2 mb-1'>
            {mainButton && <div className='flex flex-col gap-2'>
              {currentCard === cards.length - 1
                ? <Button variant='primary' onClick={mainButton.onClick}>{mainButton.title}</Button>
                : <div className="h-11"></div>
              }
            </div>}
            {secondaryButton && <div className={'flex flex-col gap-2'}>
              {currentCard !== cards.length - 1
                ? <Button variant='tertiary' onClick={secondaryButton.onClick}>{secondaryButton.title}</Button>
                : <div className="h-11"></div>
              }
            </div>}
          </div>
        </div>
      </div>}

      {isOpen && (screenSize === 'lg' || screenSize === 'xl' || screenSize === '2xl') && <div>
        <CustomModal
          isOpen={isOpen}
          onRequestClose={() => { }}
          hideCancelButton
          card
        >

          <div className="flex flex-col gap-2 px-6 py-4 min-h-[50vh] min-w-[60vh] max-w-[60vh]">
            <div className='absolute top-6 right-6 cursor-pointer' onClick={() => setIsOpen(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6L18 18" stroke="#AD1781" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>

            <div className='flex flex-col gap-2'>
              {cards[currentCard]}
            </div>

            <div className='flex flex-col justify-end mt-auto gap-4'>
              <div className='flex flex-row justify-between gap-2'>
                {currentCard > 0 && <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" onClick={() => setCurrentCard(currentCard - 1)} className='cursor-pointer'>
                  <path d="M30 36L18 24L30 12" stroke="#AD1781" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                </svg>}

                {currentCard < cards.length - 1 && <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" onClick={() => setCurrentCard(currentCard + 1)} className='ml-auto cursor-pointer'>
                  <path d="M18 36L30 24L18 12" stroke="#AD1781" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                </svg>}
              </div>

              <div className='flex flex-col gap-4 mt-2'>
                {mainButton && <div className='flex flex-col gap-2'>
                  {currentCard === cards.length - 1
                    ? <Button variant='primary' onClick={mainButton.onClick}>{mainButton.title}</Button>
                    : <div className="h-11"></div>
                  }
                </div>}
                {secondaryButton && <div className={'flex flex-col gap-2'}>
                  {currentCard !== cards.length - 1
                    ? <Button variant='tertiary' onClick={secondaryButton.onClick}>{secondaryButton.title}</Button>
                    : <div className="h-11"></div>
                  }
                </div>}
              </div>

            </div>
          </div>

        </CustomModal>
      </div>}
    </>
  );
};

export default OnBoardingCard;
